module.exports = __webpack_public_path__ + "static/media/refrescos.eff91e49.jpg";